import getAddToCalendarButton from './getAddToCalendarButton';
import getEditButtons from './getEditButtons';
import getEditDropDownButton from './getEditDropDownButton';
import getOpenInGoogleButton from './getOpenInGoogleButton';
import getSaveToCloudButton from './getSaveToCloudButton';
import getOpenCloudyDocumentInNewTabButton from './getOpenCloudyDocumentInNewTabButton';
import getTextPreviewEncodingOptions from './getTextPreviewEncodingOptions';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    getDefaultPreviewPaneCommandBarItems,
    PreviewPaneCommandBarItem,
} from 'owa-sxs/lib/utils/PreviewPaneCommandBarButton';

export default function getCommandBarButtonsForMail(sxsId: string): PreviewPaneCommandBarItem[] {
    return isFeatureEnabled('wvn-productizeSTCChicletAndPreview')
        ? [
              getEditDropDownButton(sxsId),
              getSaveToCloudButton(sxsId),
              ...getEditButtons(sxsId),
              getAddToCalendarButton(sxsId),
              getOpenInGoogleButton(sxsId),
              ...getDefaultPreviewPaneCommandBarItems(),
              getOpenCloudyDocumentInNewTabButton(sxsId),
              getTextPreviewEncodingOptions(sxsId),
          ]
        : [
              getEditDropDownButton(sxsId),
              ...getEditButtons(sxsId),
              getAddToCalendarButton(sxsId),
              getOpenInGoogleButton(sxsId),
              ...getDefaultPreviewPaneCommandBarItems(),
              getSaveToCloudButton(sxsId),
              getOpenCloudyDocumentInNewTabButton(sxsId),
              getTextPreviewEncodingOptions(sxsId),
          ];
}
